import extreme from "@images/partners/extreme-boats.webp";
import gfab from "@images/partners/gfab-trailers.webp";
import mazda from "@images/partners/mazda.webp";
import yamaha from "@images/partners/powered-by-yamaha.webp";
import raymarine from "@images/partners/raymarine.webp";
import seadek from "@images/partners/seadek.webp";
import theDreamFactory from "@images/partners/the-dream-factory-logo-standard.svg";

export const sponsorsList = [
  {
    id: "yamaha",
    name: "Yamaha",
    href: "https://www.yamaha-motor.co.nz/",
    logo: yamaha,
    alt: "Powered by Yamaha Logo",
    active: true,
  },
  {
    id: "extreme",
    name: "Extreme Boats",
    href: "https://www.extremeboats.co.nz/",
    logo: extreme,
    alt: "Extreme Boats Logo",
    active: true,
  },
  {
    id: "gfab",
    name: "GFAB Trailers",
    href: "https://gfab.co.nz/",
    logo: gfab,
    alt: "GFAB Trailers Logo",
    active: true,
  },
  {
    id: "mazda",
    name: "Mazda",
    href: "https://www.mazda.co.nz/",
    logo: mazda,
    alt: "Mazda Logo",
    active: true,
  },
  {
    id: "raymarine",
    name: "Raymarine",
    href: "https://www.raymarine.com/en-au",
    logo: raymarine,
    alt: "Raymarine Logo",
    active: true,
  },
  {
    id: "seadek",
    name: "SeaDek",
    href: "https://www.seadek.com/",
    logo: seadek,
    alt: "Seadek logo",
    active: false,
  },
  {
    id: "dream-factory",
    name: "The Dream Factory NZ",
    href: "https://www.thedreamfactory.nz/",
    logo: theDreamFactory,
    alt: "The Dream Factory NZ logo",
    active: true,
  },
];
